import { useState } from "react";
import axios from "axios";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { Download } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function DownloadPdfButton({
  inputs,
  leadId,
  entered,
  variant = "primary",
  testId = "download-pdf-btn",
  label = "Download My Passive Income Blueprint (PDF)",
  shortLabel = "Download Blueprint (PDF)",
}) {
  const [loading, setLoading] = useState(false);

  const handleClick = async () => {
    if (!entered) return;
    try {
      setLoading(true);
      const body = {
        monthly_expenses: inputs.monthlyExpenses,
        current_age: inputs.currentAge,
        freedom_age: inputs.freedomAge,
        annual_return: inputs.annualReturn,
        annual_inflation: inputs.annualInflation,
        stepup_pct: inputs.stepupPct,
        lead_id: leadId || undefined,
      };
      const res = await axios.post(`${API}/generate-pdf`, body, {
        responseType: "blob",
      });
      const url = URL.createObjectURL(
        new Blob([res.data], { type: "application/pdf" }),
      );
      const a = document.createElement("a");
      a.href = url;
      a.download = "Sahi-Disha-Passive-Income-Blueprint.pdf";
      document.body.appendChild(a);
      a.click();
      a.remove();
      URL.revokeObjectURL(url);
      toast.success(
        "Your blueprint is downloading. A Sahi Disha advisor will call you shortly.",
      );
    } catch (_e) {
      toast.error("Could not generate PDF. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  const classes =
    variant === "primary"
      ? "w-full h-11 sm:h-14 bg-[#F97316] hover:bg-[#EA580C] text-white text-sm sm:text-base font-medium shadow-lg shadow-orange-500/20 whitespace-normal leading-tight"
      : "w-full sm:w-auto h-12 bg-[#F97316] hover:bg-[#EA580C] text-white text-sm sm:text-base font-medium shadow-lg shadow-orange-500/20 whitespace-normal leading-tight px-6";

  return (
    <Button
      onClick={handleClick}
      disabled={loading || !entered}
      className={classes}
      data-testid={testId}
    >
      <Download className="w-4 h-4 sm:w-5 sm:h-5 mr-2 shrink-0" />
      <span className="hidden sm:inline">{loading ? "Preparing…" : label}</span>
      <span className="sm:hidden">{loading ? "Preparing…" : shortLabel}</span>
    </Button>
  );
}
